<template>
  <md-modal-dialog v-slot="{ title, message }" class="md-modal-dialog-waiting-dialog"
  :md-close-on-esc="false"
  :md-click-outside-to-close="false">
    <md-dialog-title>
      {{ title }}
    </md-dialog-title>
    <md-dialog-content>
      <img class="loading-animation" :src="img_src" />
      <p>{{ message }}</p>
    </md-dialog-content>
  </md-modal-dialog>
</template>

<script>
let img_src = require("@/assets/img/zink-logo-loading-animation-color.gif");

export default {
  data() {
    return {
      img_src,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/theme.scss";

.md-dialog-container {

  & .md-dialog-title {
    padding-bottom: 20px;
    margin-bottom: 0px;

    background: $ausloans-blue-hover !important;
    color: $color-text-on-dark !important;
  }

  & .md-dialog-content {

    display: flex;
    flex-direction: column;

    background: $ausloans-blue-hover !important;
    color: $color-text-on-dark !important;

    & img {
      width: 100px;
      align-self: center;
    }
    & p {
      margin-top: 16px;
    }
  }
}
</style>
